// import React from "react";
// import { DownloadCloud } from "lucide-react";
// import GenericPremiumPage from "../../../customComponents/GenericPremiumPage";

// const DownloadAppPage = () => (
//   <GenericPremiumPage
//     title="Download Our App"
//     subtitle="Trade crypto anytime, anywhere."
//     icon={DownloadCloud}
//     description="Get the full power of ARAB Global Exchange in your pocket. Available on iOS and Android with premium charting and instant alerts. Contact support if you need help getting started on mobile."
//     contentTitle="Mobile Trading"
//     ctaText="Contact Support"
//     ctaLink="/contact"
//   />
// );

// export default DownloadAppPage;


import React, { useState } from "react";
import { Zap, Globe, ShieldCheck, Download, ArrowDownToLine, LayoutGrid } from "lucide-react";
import "./downloadapp.css";

const AppleIcon = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 170 170" fill={color}>
    <path d="M150.37 130.25c-2.45 5.66-5.35 10.87-8.71 15.66-4.58 6.53-8.33 11.05-11.22 13.56-4.48 4.12-9.28 6.23-14.42 6.35-3.69 0-8.14-1.05-13.32-3.18-5.19-2.12-9.97-3.17-14.34-3.17-4.58 0-9.49 1.05-14.75 3.17-5.26 2.13-9.5 3.24-12.74 3.35-4.88.13-9.74-1.93-14.58-6.19-3.26-2.83-7.14-7.53-11.66-14.1-6.74-9.8-12.03-20.91-15.86-33.32-3.83-12.41-5.75-24.16-5.75-35.25 0-14.58 3.75-26.69 11.25-36.33 7.5-9.64 16.96-14.61 28.38-14.91 4.79 0 10.15 1.25 16.08 3.75 5.93 2.5 9.94 3.75 12.03 3.75 1.85 0 5.93-1.29 12.24-3.87 6.31-2.58 11.45-3.79 15.42-3.63 11.31.54 20.35 4.54 27.12 12 5.01 5.44 8.71 11.75 11.1 18.93-10.01 6.09-15.01 14.36-15.01 24.8 0 8.05 2.83 15.12 8.49 21.2 5.66 6.08 12.56 9.8 20.7 11.16-2.18 6.53-5.07 13.06-8.67 19.59zM119.22 31.06c0-6.74 2.39-13.38 7.18-19.91 4.79-6.53 10.88-10.88 18.28-13.06.22 1.3.33 2.39.33 3.26 0 6.85-2.45 13.54-7.35 20.07-4.9 6.53-10.99 10.87-18.28 13.01-.05-.44-.16-1.57-.16-3.37z" />
  </svg>
);

const AndroidIcon = ({ size = 18, color = "currentColor" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill={color}>
    <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.552 0 .9997.4482.9997.9993.0001.5511-.4477.9997-.9997.9997zm-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.552 0 .9997.4482.9997.9993 0 .5511-.4477.9997-.9997.9997zm11.4045-6.02l1.9973-3.4592c.1316-.228.0534-.5193-.1746-.6509-.228-.1316-.5193-.0534-.6509.1746l-2.0232 3.5042c-1.4646-.6692-3.1368-1.0501-4.9301-1.0501s-3.4655.3809-4.9301 1.0501l-2.0232-3.5042c-.1316-.228-.4229-.3062-.6509-.1746-.228.1316-.3062.4229-.1746.6509l1.9973 3.4592c-3.1518 1.7139-5.3129 4.9082-5.597 8.6547h22.6844c-.2841-3.7465-2.4452-6.9408-5.597-8.6547z" />
  </svg>
);

const GooglePlayIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 512 512">
    <path fill="#415A77" d="M99.617 8.057a50.06 50.06 0 0 0-38.867 19.65L280.973 256.02 60.75 484.293a50.06 50.06 0 0 0 38.867 19.65 49.88 49.88 0 0 0 22.846-5.637l254.67-147.03 2.05-1.185-98.21-94.07-98.21-94.07 2.05-1.185L122.463 13.694a49.88 49.88 0 0 0-22.846-5.637z" />
    <path fill="#00A0FF" d="M60.75 27.707v456.586l220.223-228.293z" />
    <path fill="#00C853" d="M379.18 350.091l71.21-41.115c26.97-15.57 26.97-59.38 0-74.95l-71.21-41.115-98.207 98.21z" />
    <path fill="#FF3D00" d="M60.75 484.293l220.223-228.273 98.207 94.071-256.717 148.216c-7.067 4.08-14.99 6.22-22.846 6.22-14.86 0-29.21-7.53-38.867-20.234z" />
    <path fill="#FFC107" d="M379.18 161.909L122.463 13.694A49.88 49.88 0 0 0 99.617 8.057c-14.86 0-29.21 7.53-38.867 20.234l220.223 227.729z" />
  </svg>
);

const DownloadOurApp = () => {
  const [activeTab, setActiveTab] = useState("android");

  const apkDownloadUrl = window.location.origin + "/images/apk-1758815756412-532361059%20(2).apk";
  const iosDownloadUrl = "https://apps.apple.com";

  return (
    <div
      className="download-app-section"
      style={{
        backgroundImage: "url(/images/download-app/bg-image.png)",
      }}
    >
      <div className="download-app-container">
        {/* Left Content Area */}
        <div className="download-app-content">
          <h1 className="download-app-title">
            The exchange that <br /> goes where you go.
          </h1>
          <p className="download-app-subtitle">
            Trade anytime, anywhere with premium charts and instant price alerts, on iPhone and Android.
          </p>

          {/* Glassmorphic Download Box */}
          <div className="download-glass-card">
            {/* Tab Switcher */}
            <div className="app-tab-nav">
              <button
                className={`tab-btn ${activeTab === "iphone" ? "active" : ""}`}
                onClick={() => setActiveTab("iphone")}
              >
                <img src="/images/download-app/iphone_icon.svg" alt="iPhone" width={18} className="tabicon" />
                <span>iPhone</span>
              </button>
              <button
                className={`tab-btn ${activeTab === "android" ? "active" : ""}`}
                onClick={() => setActiveTab("android")}
              >
                <img src="/images/download-app/android_icon.svg" alt="Android" width={18} className="tabicon" />
                <span>Android</span>
              </button>
            </div>

            {/* Main Card Grid */}
            <div className="card-body-grid">
              {/* Left Column: Download Buttons & Instructions */}
              <div className="card-left-col">
                <div className="download-buttons-group">
                  {activeTab === "android" ? (
                    <>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.agcx.exchange&pcampaignid=web_share"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-google-play"
                      >
                        <img src="/images/download-app/play_store.svg" alt="Google Play" width={18} className="tabicon" />
                        <span>Google Play</span>
                      </a>
                      <a
                        href="/images/apk-1758815756412-532361059%20(2).apk"
                        download
                        className="btn-direct-apk"
                      >
                        <img src="/images/download-app/apk_icon.svg" alt="Google Play" width={18} className="tabicon" />
                        <span>Direct APK</span>
                      </a>
                    </>
                  ) : (
                    <>
                      <a
                        href={iosDownloadUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-app-store appstorebtn"
                      >
                        <img src="/images/download-app/app-store.svg" alt="App Store" width={18} className="tabicon" />
                        <span>App Store</span>
                      </a>
                      <a
                        href="https://testflight.apple.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn-direct-apk"
                      >
                        <img src="/images/download-app/testflight-svg.svg" alt="TestFlight" width={18} className="tabicon" />
                        <span>TestFlight</span>
                      </a>
                    </>
                  )}
                </div>

                {/* Instruction Steps */}
                <div className="instructions-list">
                  <div className="step-item">
                    <div className="step-icon-badge">
                      <ArrowDownToLine size={16} />
                    </div>
                    <span className="step-text">
                      {activeTab === "android"
                        ? "Tap Google Play, or scan the code"
                        : "Tap App Store, or scan the code"}
                    </span>
                  </div>

                  <div className="step-item">
                    <div className="step-icon-badge">
                      <Download size={16} />
                    </div>
                    <span className="step-text">Tap Install</span>
                  </div>

                  <div className="step-item">
                    <div className="step-icon-badge">
                      <LayoutGrid size={16} />
                    </div>
                    <span className="step-text">Open AGCX and log in</span>
                  </div>
                </div>

                <div className="helper-note">
                  {activeTab === "android"
                    ? "Using the APK? Allow installs from this source when asked."
                    : "Requires iOS 14.0 or later. Compatible with iPhone."}
                </div>
              </div>

              {/* Right Column: QR Code Box */}
              <div className="card-qr-col">
                <div className="qr-wrapper">
                  <div className="qr-box_scan">
                    <img
                      src="/images/download-app/qrimage.png"
                      alt="AGCX App Download QR Code"
                      className="qr-code-img"
                    />
                  </div>
                  <p className="qr-caption">Scan to open on your phone</p>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Features Row */}
          <div className="features-row">
            <div className="feature-item">
              <img src="/images/download-app/fast_secure_icon.png" alt="Fast and Secure" width={22} className="security_icon" />
              <span>Fast and Secure</span>
            </div>
            <div className="feature-item">
              <img src="/images/download-app/global_access_icon.png" alt="Global Access" width={26} className="security_icon" />
              <span>Global Access</span>
            </div>
            <div className="feature-item">
              <img src="/images/download-app/security_icon.png" alt="Bank-Grade Security" width={22} className="security_icon" />
              <span>Bank-Grade Security</span>
            </div>
          </div>
        </div>

        {/* Right Mobile Phone Positioned over Background Pedestal */}
        <div className="download-app-visual">
          <img
            src="/images/download-app/mobile-img.png"
            alt="AGCX Mobile App Interface"
            className="mobile-graphic-overlay"
          />
        </div>
      </div>
    </div>
  );
};

export default DownloadOurApp;
